import { AgreementsDocumentsService } from './AgreementsDocumentsService'
import { AgreementsSignaturesService } from './AgreementsSignaturesService'
import type { HttpClient } from '~/shared/api'

export class AgreementsService {
  readonly documents: AgreementsDocumentsService
  readonly signatures: AgreementsSignaturesService

  constructor(http: HttpClient) {
    this.documents = new AgreementsDocumentsService(http)
    this.signatures = new AgreementsSignaturesService(http)
  }
}
